import { api } from './client';

export interface CatalogueRow {
  id: number;
  code: string;
  name: string;
  category: string;
  brand: string | null;
  unit: string;
  hsn: string | null;
  gstPct: number;
  imageUrl: string | null;
  mrp: number;
  distPrice: number | null;
  dealerPrice: number | null;
  customerPrice: number;
  currentStock: number;
  reservedQty: number;
  availableQty: number;
  reorderLevel: number | null;
  stockStatus: 'GREEN' | 'AMBER' | 'RED';
  barcode: string | null;
  color: string | null;
  size: string | null;
  style: string | null;
  collection: string | null;
}

export async function listCatalogue(filter: {
  category?: string;
  brand?: string;
  collection?: string;
  inStock?: boolean;
  search?: string;
  customerType?: string;
  full?: boolean;
  limit?: number;
} = {}): Promise<CatalogueRow[]> {
  const r = await api.get<CatalogueRow[]>('/catalogue', { params: filter });
  return r.data;
}

export async function fetchCatalogueCategories(): Promise<string[]> {
  const r = await api.get<string[]>('/catalogue/categories');
  return r.data;
}

export async function fetchCatalogueCollections(): Promise<{ name: string; items: number }[]> {
  const r = await api.get<{ name: string; items: number }[]>('/catalogue/collections');
  return r.data;
}

export async function fetchCatalogueBrands(): Promise<string[]> {
  const r = await api.get<string[]>('/catalogue/brands');
  return r.data;
}

